import { theme } from 'antd';
import { FC } from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
  disabledColor?: string;
  onClick?: () => void;
  className?: string;
};

const { useToken } = theme;

const TrashSecondaryIcon: FC<Props> = ({
  width = 24,
  height = 25,
  color,
  disabled,
  disabledColor,
  onClick,
  className,
}) => {
  const { token } = useToken();

  const iconColor = color || token.colorIcon;
  const iconDisabledColor = disabledColor || token.colorIcon;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <g id="Trash">
        <path
          id="Vector"
          d="M20.25 5.2876H16.3125V4.3501C16.3125 3.80309 16.0952 3.27848 15.7084 2.89169C15.3216 2.5049 14.797 2.2876 14.25 2.2876H9.75C9.20299 2.2876 8.67839 2.5049 8.29159 2.89169C7.9048 3.27848 7.6875 3.80309 7.6875 4.3501V5.2876H3.75C3.60082 5.2876 3.45774 5.34686 3.35225 5.45235C3.24676 5.55784 3.1875 5.70091 3.1875 5.8501C3.1875 5.99928 3.24676 6.14236 3.35225 6.24785C3.45774 6.35333 3.60082 6.4126 3.75 6.4126H4.6875V20.1001C4.6875 20.4482 4.82578 20.782 5.07192 21.0282C5.31806 21.2743 5.6519 21.4126 6 21.4126H18C18.3481 21.4126 18.6819 21.2743 18.9281 21.0282C19.1742 20.782 19.3125 20.4482 19.3125 20.1001V6.4126H20.25C20.3992 6.4126 20.5423 6.35333 20.6477 6.24785C20.7532 6.14236 20.8125 5.99928 20.8125 5.8501C20.8125 5.70091 20.7532 5.55784 20.6477 5.45235C20.5423 5.34686 20.3992 5.2876 20.25 5.2876ZM8.8125 4.3501C8.8125 4.10146 8.91127 3.863 9.08709 3.68719C9.2629 3.51137 9.50136 3.4126 9.75 3.4126H14.25C14.4986 3.4126 14.7371 3.51137 14.9129 3.68719C15.0887 3.863 15.1875 4.10146 15.1875 4.3501V5.2876H8.8125V4.3501ZM18.1875 20.1001C18.1875 20.1498 18.1677 20.1975 18.1326 20.2327C18.0974 20.2678 18.0497 20.2876 18 20.2876H6C5.95027 20.2876 5.90258 20.2678 5.86742 20.2327C5.83225 20.1975 5.8125 20.1498 5.8125 20.1001V6.4126H18.1875V20.1001ZM10.3125 10.3501V16.3501C10.3125 16.4993 10.2532 16.6424 10.1477 16.7478C10.0423 16.8533 9.89918 16.9126 9.75 16.9126C9.60082 16.9126 9.45774 16.8533 9.35225 16.7478C9.24676 16.6424 9.1875 16.4993 9.1875 16.3501V10.3501C9.1875 10.2009 9.24676 10.0578 9.35225 9.95235C9.45774 9.84686 9.60082 9.7876 9.75 9.7876C9.89918 9.7876 10.0423 9.84686 10.1477 9.95235C10.2532 10.0578 10.3125 10.2009 10.3125 10.3501ZM14.8125 10.3501V16.3501C14.8125 16.4993 14.7532 16.6424 14.6477 16.7478C14.5423 16.8533 14.3992 16.9126 14.25 16.9126C14.1008 16.9126 13.9577 16.8533 13.8523 16.7478C13.7468 16.6424 13.6875 16.4993 13.6875 16.3501V10.3501C13.6875 10.2009 13.7468 10.0578 13.8523 9.95235C13.9577 9.84686 14.1008 9.7876 14.25 9.7876C14.3992 9.7876 14.5423 9.84686 14.6477 9.95235C14.7532 10.0578 14.8125 10.2009 14.8125 10.3501Z"
          fill={disabled ? iconDisabledColor : iconColor}
        />
      </g>
    </svg>
  );
};

export default TrashSecondaryIcon;
